import DiscountNudgerSFC from "./DiscountNudger.vue";
export const DiscountNudger = DiscountNudgerSFC;
